import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SvPipelineInfo } from '@models';

@Pipe({
  standalone: false, name: 'svPipeline', pure: true })
export class ScoutViewPipelinePipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string): any {
    if (typeof value !== 'string') {
      return value;
    }
    // const highReg = new RegExp(match, 'ig');
    // const highlighted = value.replace(highReg, '<span style="background-color: yellow">' + match + '</span>');
    //return this.sanitized.bypassSecurityTrustHtml(highlighted);
    const object = JSON.parse(value);
    if (object.PipelineName === undefined || object.ProcessStepNames === undefined || object.ProcessStepNames.length === 0) return '';

    const html = `<span>${object.PipelineName}</span><ul>${object.ProcessStepNames.map(p => '<li>' + p + '</li>').join('')}</ul>`;
    return this.sanitized.bypassSecurityTrustHtml(html);
  }
}
